var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.8138 9.36245C15.5647 11.3076 14.631 11.6369 12.7943 11.8022C11.2068 11.9339 9.40136 12 8.00058 12C6.5998 12 4.76312 11.9339 3.20682 11.8022C1.36956 11.6376 0.404683 11.3076 0.155514 9.36245C0.0618587 8.47224 0 7.25265 0 6C0 4.74735 0.0624368 3.49469 0.155514 2.63755C0.404683 0.659387 1.36956 0.363059 3.20624 0.197753C4.76254 0.0330591 6.59922 -1.90735e-06 8 -1.90735e-06C9.40078 -1.90735e-06 11.2062 0.0330591 12.7938 0.197753C14.6304 0.362447 15.5641 0.659387 15.8133 2.63755C15.9376 3.49469 16 4.74735 16 6C16 7.25265 15.9376 8.47224 15.8133 9.36245H15.8138ZM6.38185 3.42857V8.53837L10.553 6L6.38185 3.42857Z"}));
}

Youtube.defaultProps = {"width":"16","height":"12","viewBox":"0 0 16 12","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
